/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from 'flickity';
import { debounce } from "debounce";

/*------------------------------------*\
    NAVIGATION MODULE
\*------------------------------------*/
class MultiCarousel {
    constructor(passedElement) {
        let self = this;

        self.flkty;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.flkty = self.createFlkty();
        
        // let carouselVisible = document.querySelectorAll('.extra-items');

        // function disableCarousel() {
        //     if ( matchMedia('screen and (min-width: 2050px)').matches ) {
        //         self.flkty.destroy();
        //         self.elem.classList.add('d-flex');
        //         for (let i = 0; i < carouselVisible.length; i++) {
        //             carouselVisible[i].classList.add('d-none');
        //         }
        //     } else {
        //         self.flkty = self.createFlkty();
        //         self.elem.classList.remove('d-flex');
        //         for (let i = 0; i < carouselVisible.length; i++) {
        //             carouselVisible[i].classList.remove('d-none');
        //         }
        //     }

        // }

        // // window.addEventListener("resize", disableCarousel);

        // disableCarousel();

        // window.addEventListener('resize', evt => {
        //     // debounce(disableCarousel(), 200);
        //     disableCarousel();
        // });

    }

    createFlkty() {
        let self = this;

        return new Flickity( self.elem, {
          // options
          cellAlign: 'left',
          contain: false,
          selectedAttraction: 0.01,
          friction: 0.15,
          wrapAround: true,
          pageDots: false,
          watchCSS: true,
          watch: true,
          draggable: true,
          prevNextButtons: true
        });
    }
}

export default MultiCarousel;
